import ReactDOM from 'react-dom';
import './BottomSheet.css'
import { Dispatch, forwardRef, SetStateAction, useEffect, useImperativeHandle, useRef, useState } from 'react';

interface BottomSheetProps {
    children: React.ReactNode
    isOpen: boolean
    setIsOpen: Dispatch<SetStateAction<boolean>>
}

export const BottomSheet = ({children, isOpen, setIsOpen} : BottomSheetProps) => {
    const portalRoot = document.getElementById("portal");
    const [isVisible, setIsVisible] = useState(false);
    const scrimRef = useRef<HTMLDivElement>(null);
    const bottomSheetRef = useRef<HTMLDivElement>(null);

    const openTimer = useRef<NodeJS.Timer | undefined>(undefined);
    const closeTimer = useRef<NodeJS.Timer | undefined>(undefined);


    const openBottomSheet = () => {
        if(closeTimer.current) clearTimeout(closeTimer.current);
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                bottomSheetRef.current?.classList.add("open");
                scrimRef.current?.classList.add("open");        
            })
        })
        
    }

    const closeBottomSheet = () => {
        if(openTimer.current) clearTimeout(openTimer.current);
        bottomSheetRef.current?.classList.remove("open");
        scrimRef.current?.classList.remove("open");
        closeTimer.current = setTimeout(() => {
            setIsOpen(false);
            setIsVisible(false);       
        }, 300)
    }

    useEffect(() => {
        if(isOpen) {
            setIsVisible(true);
        } else {
            closeBottomSheet();
        }
    },[isOpen])

    useEffect(() => {
        if(isVisible) {
            openBottomSheet();
        }
    },[isVisible])

    if(!portalRoot || !isVisible) return null;

    return ReactDOM.createPortal(
        <div
            className="bottom-sheet-container"
        >
            <div className="bottom-sheet-scrim"
                onClick={() => {
                    closeBottomSheet();
                }}
                ref={scrimRef}
            />
            <div
                className={"bottom-sheet"}
                ref={bottomSheetRef}
            >
                {children}
            </div>
        </div>
    , portalRoot)
};